import routes from "../../../utils/routes";
import { useState, useRef } from "react";
import { ReactComponent as InfoIcon } from "../../../Assets/Icons/info.svg";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import sortCountryList from "../../../utils/sortCountry";
// import { ReactComponent as ChevronDown } from '../../../Assets/Icons/chevron_down.svg';
import Tooltip from "@material-ui/core/Tooltip";

const DesktopDropdown = ({ countries = [] }) => {
  const { pathname } = useLocation();
  const nonFocusedRef = useRef(null);
  const [isNonFocusedOpen, setIsNonFocusedOpen] = useState(false);

  const toggleIsNonFocusedOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (nonFocusedRef.current) {
      nonFocusedRef.current.checked = !nonFocusedRef?.current?.checked;
    }
    setIsNonFocusedOpen((prev) => !prev);
  };

  const [focusedCountry, nonFocusedCountry] = sortCountryList(
    countries,
    routes
  );

  return (
    <div className="overflow-scroll z-10 min-h-536">
      <div className="layout__wrapper ">
        <div className=" flex  justify-end py-10 items-start">
          <ul className="flex-grow">
            <li className=" font-normal font-ubuntu text-xs leading-14 mb-6 ">
              <span className="flex items-center  text-chocolateKiss font-ubuntu">
                <Tooltip
                  title="We have decided to focus on 7 african countries so we will be able to produce the factsheets, whistle blow corruption cases and ensure the value of the funds donated to these countries are well utilized.   
                    "
                  arrow
                >
                  <InfoIcon className="cursor-pointer" />
                </Tooltip>
                <span className="ml-2">FOCUS COUNTRIES*</span>
              </span>
            </li>
            <li>
              <ul className="grid  grid-cols-1 grid-rows-12 gap-2 overflow-scroll text-chocolateKiss ">
                {focusedCountry?.map((nav) => {
                  return (
                    <li
                      className={clsx({
                        "font-normal text-xs mb-1 last:mb-0": true,
                        " text-chestNut": pathname.includes(nav?.path),
                      })}
                    >
                      <Link to={nav?.path}>
                        <span className=" w-full flex items-center   leading-34 tracking-wide ">
                          <span className="mr-2">{nav?.title}</span>
                          <span className="w-4 h-4 flex items-center">
                            <img src={nav?.flag} alt="flag" />
                          </span>
                        </span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </li>
          </ul>
          <ul className=" w-4/5">
            {" "}
            <li className=" font-normal font-ubuntu text-xs leading-14 mb-6">
              <button
                onClick={toggleIsNonFocusedOpen}
                className="flex items-center  text-chocolateKiss font-ubuntu outline-none focus:outline-none"
              >
                <Tooltip
                  title="These are countries which are not part of the seven focused countries"
                  arrow
                >
                  <InfoIcon className="cursor-pointer" />
                </Tooltip>
                <span className="mx-2">NON-FOCUS COUNTRIES</span>
                {
                  <span
                    className={clsx({
                      transition: true,
                      "transform -rotate-180": isNonFocusedOpen,
                    })}
                  >
                    {/* <ChevronDown /> */}
                  </span>
                }
              </button>
            </li>
            <input
              type="checkbox"
              ref={nonFocusedRef}
              className=" nonFocusedToggler hidden"
            />
            {
              <li
                className={clsx({
                  nonFocusedList: true,
                })}
              >
                <ul className="grid  grid-cols-4 grid-rows-12 gap-4 overflow-scroll text-chocolateKiss ">
                  {nonFocusedCountry?.map((nav) => {
                    return (
                      <li
                        className={clsx({
                          "font-normal text-xs mb-1 last:mb-0": true,
                          " text-chestNut": pathname.includes(nav?.path),
                        })}
                      >
                        <Link to={nav?.path}>
                          <span className=" w-full inline-block   ">
                            {nav?.title}
                          </span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DesktopDropdown;
